import { render, staticRenderFns } from "./ChartProfitYear.vue?vue&type=template&id=65ddb472&scoped=true&"
import script from "./ChartProfitYear.vue?vue&type=script&lang=js&"
export * from "./ChartProfitYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ddb472",
  null
  
)

export default component.exports